import { render, staticRenderFns } from "./ed-subject-component-item.component.vue?vue&type=template&id=6f871fb7&scoped=true&"
import script from "./ed-subject-component-item.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-component-item.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-component-item.component.scss?vue&type=style&index=0&id=6f871fb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f871fb7",
  null
  
)

export default component.exports